<template>
    <div class="overflow-hidden h-[100dvh] relative block">
        <Organism3DEnv :data="events" ref="3DEnv" />
    </div>
</template>

<script>
import Organism3DEnv from "../components/anarchive/organisms/Organism3DEnv.vue";
import {mapGetters} from "vuex";

export default {
    name: 'PageAnarchiveChrono',
    components: {
        Organism3DEnv,
    },

    computed: {
        ...mapGetters('event', {
            events: 'getFilteredAnarchiveEvents',
        }),
        env3D: function (){
            return this.$refs['3DEnv']
        }
    },

    methods: {
        passToNextStack(){
            this.env3D?.passToNextStack()
        },

        passToPreviousStack(){
            this.env3D?.passToPreviousStack()
        },

        handlePlus(){
            this.passToNextStack();
        },

        handleMinus() {
            this.passToPreviousStack();
        }
    },
}
</script>
